import React from 'react';

import {
  BritzLogo,
  MauiLogo,
  MightyLogo,
  MonteRVLogo,
  RoadBearLogo,
  THLLogo,
  JustGoLogo,
  ApolloLogo,
  BunkCampersLogo,
} from './index';
import { Logo, LogoName } from './Logo';

export const groupCodeLogoMapping = {
  B: BritzLogo,
  M: MauiLogo,
  Y: MightyLogo,
  R: RoadBearLogo,
  E: MonteRVLogo,
  J: JustGoLogo,
  A: ApolloLogo,
  N: BunkCampersLogo,
  C: () => <Logo name={LogoName.coloredCheapa} />,
  H: () => <Logo name={LogoName.coloredHippie} />,
};

export const defaultLogo = THLLogo;
